module.exports = __webpack_public_path__ + "static/media/WA1.4251d0c1.png";